<template>
  <div class="newsletter-signup-wrapper">
    <div class="newsletter checkbox">
      <input
        id="newsletter-signup"
        class="newsletter-signup"
        :class="{ selected: newsletterState }"
        type="checkbox"
        @click="toggleNewsletterSignupState"
        name="newsletter-signup"
        :value="newsletterState"
        :checked="newsletterState"
      />
      <span class="checkmark" @click="toggleNewsletterSignupState"></span>
      <label class="shopping-cart__sidebar-label" for="newsletter-signup" v-html="$t('message.newsletter_signup')"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsletter-signup",
  props: {
    newsletterState: {
      type: Boolean,
      required: true
    },
  },
  methods: {
    toggleNewsletterSignupState() {
      this.$emit('toggleNewsletterSignupState')
    }
  }
}
</script>